/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export function transformModelPayload (model) {
    let banner = model?.banner_image;
    try {
        banner = JSON.parse(model?.banner_image);
    } catch (err) {
        console.error(err);
    }
    const payload = {
        guid: model.guid,
        type: model.type,
        version: model.version,
        title: model.title,
        description: model.description,
        banner_image: banner || null,
        fields: [],
    };

    return payload;
}
